// const API_BASE_URL = 'http://localhost:5000';
const API_BASE_URL = 'https://wabackend.smartitbox.in';
// const API_BASE_URL = 'https://whatsapp-api-backend-1.onrender.com';
// const API_BASE_URL = 'https://whatsapp-api-backend-fawn.vercel.app';


export { API_BASE_URL };
